export function roundNumber (num, decimals = 2) {
    let multiplier = Math.pow(10, decimals);
    return Math.round((num + Number.EPSILON) * multiplier) / multiplier
}